import { render, staticRenderFns } from "./CouponHistorySection.vue?vue&type=template&id=28bab908&scoped=true&"
import script from "./CouponHistorySection.vue?vue&type=script&lang=js&"
export * from "./CouponHistorySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bab908",
  null
  
)

export default component.exports